import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "\"Startup rollercoaster\" isn't even the half of it",
  "description": "",
  "published": "2011-10-25T00:00:00.000Z",
  "redirect_from": ["/blog/startup-rollercoaster-isnt-even-the-half-of-it/swizec/2712"],
  "categories": "Business, Opinions, Personal, Startups",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A year ago, to the day, I was sitting in `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Om_Malik"
      }}>{`Om Malik`}</a>{`'s office in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.7793,-122.4192&spn=0.1,0.1&q=37.7793,-122.4192%20(San%20Francisco)&t=h",
        "title": "San Francisco"
      }}>{`San Francisco`}</a>{`. We were discussing a possible writeup about Preona/`}<a parentName="p" {...{
        "href": "http://yukaii.com/web/lazyreadr/"
      }}>{`LazyReadr`}</a>{` on `}<a parentName="p" {...{
        "href": "http://www.gigaom.com",
        "title": "Om Malik"
      }}>{`GigaOM`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/tumblr_ltmfltFSp91qekjngo1_500.jpg",
        "alt": null,
        "title": "postme.me 2nd batch"
      }}></img></p>
    <p>{`I know it was exactly a year ago because I remember saying something like `}<em parentName="p">{`"Oh I'm 23 ... wait, I'm 23 TODAY!"`}</em>{` when he asked how old I was.`}</p>
    <p>{`About a year before I set out on a voyage that would cement my decision to do `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Startup_company",
        "title": "Startup company"
      }}>{`startups`}</a>{`. With the help of some ultra early investorvisers (adviser+investor) I founded my first company and plunged off the deep end; fully expecting to build the plane before my head smashed into the jagged rocks below.`}</p>
    <p>{`I'd been working practically full time on `}<a parentName="p" {...{
        "href": "http://twitulater.com/",
        "title": "Twitulater"
      }}>{`Twitulater`}</a>{` beforehand, but this was different, this evolved out of that original nugget and I remember thinking to myself "`}<em parentName="p">{`Shit just got real brah!"`}</em></p>
    <p>{`And it did, it did get real! I was ready to face anything anyone would throw at me. People were saying it's not all fun and games, that startup life is more like a roller coaster. Sure, it was difficult, there were hard times building a product, getting our first government grant ... rebuilding the product again from scratch over that summer because `}<a parentName="p" {...{
        "href": "http://www.apple.com/ipad/",
        "title": "iPad"
      }}>{`the iPad`}</a>{` came out and completely changed the landscape ...`}</p>
    <p>{`Those two weeks last October - looking for funding in the US, mingling with the `}<a parentName="p" {...{
        "href": "http://www.ycombinator.com",
        "title": "Y Combinator"
      }}>{`YC`}</a>{` crowd, going to awesome conferences ... I felt like I was on top of the world! `}{`_`}{`"Everything I touch turns into gold!", `}{`_`}{`I thought. Hell, out of all the seasoned veterans in that first `}<a parentName="p" {...{
        "href": "http://www.brezmejnik.si/"
      }}>{`Brezmejnik`}</a>{` batch we got the furthest with investors. Us, the young grasshoppers who but a month earlier looked like they wouldn't even have anything to pitch, we got to a verbal "yes" to participate in a round if we can pull it together.`}</p>
    <h2 {...{
      "id": "a-lot-has-changed-since-then-"
    }}>{`A lot has changed since then ...`}</h2>
    <p>{`We did not, in fact, manage to pull together a round. The fact I hadn't been making any money (full time startup plus a full time student, yeah, it doesn't work) eventually caught up with me. Around December the first rat fled the ship. Just up and stopped responding to emails.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/300px-RHP-Rollercoaster1.jpg",
        "alt": "Red House Painters (Rollercoaster)",
        "title": "Red House Painters (Rollercoaster)"
      }}></img></p>
    <p>{`Then the fighting between cofounders started. It wouldn't even be that bad if there was actual fighting. It was one of those quiet disputes that smack you when you aren't looking.`}</p>
    <p>{`At some point we stopped talking for three weeks.`}</p>
    <p><em parentName="p">{`"The product will save us!"`}</em>{`, I thought, `}<em parentName="p">{`"I need to make the fucking product! I'll finish it myself if I have to!"`}</em></p>
    <p>{`And I did try, for that month, month and a half, I was doing all the frontend and backend programming and trying to figure out where we could muster some money. Instead, I should be acting like a CEO and hiring people. `}<em parentName="p">{`Actually`}</em>{` finding money. Realising the product cannot be finished before our negative runway becomes more than `}<a parentName="p" {...{
        "href": "http://twitter.com/skatey"
      }}>{`@skatey`}</a>{` can keep up with doing consulting.`}</p>
    <p>{`Around February Skatey and our investorvisers decided that the shit has gone far enough. Swizec is an idiot, he can't code for shit, he sucks at getting money, why do we even need him? Plus he isn't paying off that debt arising from company expenses he owed to Skatey.`}</p>
    <p>{`How could I? I was pulling 80+ hour workweeks trying to keep up with all the coding and the exam season was upon me. I had that pesky school to finish!`}</p>
    <h2 {...{
      "id": "they-kicked-me-out"
    }}>{`They kicked me out.`}</h2>
    <p>{`I was able to negotiate the nullification of my debt to Skatey, but this still left me about 2000 euro in debt.`}</p>
    <p>{`2000 euro may not sound like a lot, but out of all the work the previous year I think about 800 euro made it into my pocket - I bought a phone and some clothes. Everything else went into the startup either directly or by keeping me from dying of starvation.`}</p>
    <p>{`What's more, the debt was due in four months ... I was practically bankrupt. If it wasn't for the pasta investment from my parents I'd be forced to live on the street.`}</p>
    <p>{`Here I was, 23, bankrupt, startup up in flames, the shredded remains of a guy who once thought he could take on the world and win.`}</p>
    <p>{`I was fed up with my life and myself. I was just about ready to pretty much check out ... if not literally then at least figuratively, kill this blog, kill my twitter account, everything, just get away from the world. I did the next best thing and broke up with my girlfriend of three years. In fact I cheated on her and `}<em parentName="p">{`then`}</em>{` broke up with her.`}</p>
    <p>{`Not the proudest moment of my life.`}</p>
    <h2 {...{
      "id": "it-got-better"
    }}>{`It got better`}</h2>
    <p>{`Around that time I also launched `}<a parentName="p" {...{
        "href": "http://hipstervision.org"
      }}>{`HipsterVision`}</a>{` ... a fun little project to put me in a better mood. It even got a decent amount of traffic and if I remember correctly at some point got picked up by the `}<a parentName="p" {...{
        "href": "http://www.bbc.co.uk/",
        "title": "BBC"
      }}>{`BBC`}</a>{` on a show about hot new tools online.`}</p>
    <p>{`But I had no energy to sustain growth. No ideas on how to get more traffic. No brainpower left to even contemplate making anything serious out of that project. Most of all, I simply couldn't afford to work on anything other than quickly getting some job that will enable me to pay off my debts by June, the deadline.`}</p>
    <p>{`It was April.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/152458957_9d68be3827_m1.jpg",
        "alt": "Good Times",
        "title": "Good Times"
      }}></img></p>
    <p>{`I did in fact manage to find such a job. But I was miserable, there was nothing about Slovenia that could cheer me up, I had to get away somehow, anyhow, whatever way possible. I wanted to go to the US over the summer, if push comes to shove, I'll go there without money and find a freelancing gig.`}</p>
    <p>{`A month later the offer from `}<a parentName="p" {...{
        "href": "http://doublerecall.com/#top"
      }}>{`DoubleRecall`}</a>{` came that I can join them in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.4291666667,-122.138055556&spn=0.1,0.1&q=37.4291666667,-122.138055556%20(Palo%20Alto%2C%20California)&t=h",
        "title": "Palo Alto, California"
      }}>{`Palo Alto`}</a>{` during their YC experience.`}</p>
    <p>{`I ditched my job. Just stopped responding to emails.`}</p>
    <p>{`Another not very proud moment in my life. It was a soul sucking lucrative job with a bad culture fit. But ditching them like that wasn't a very nice thing to do.`}</p>
    <p>{`But I paid off my debt by June. Nobody would come knocking at the door to take my socks!`}</p>
    <h2 {...{
      "id": "it-is-now-october"
    }}>{`It is now October.`}</h2>
    <p>{`I'm not quite at the same heights I was a year ago. The `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-suck-at-formal-education-or-does-education-suck/swizec/2564",
        "title": "I suck at [formal] education or does education suck?"
      }}>{`exam fiasco`}</a>{` that was September didn't do much for my mood, but at least I'm not in too much shit financially. Two weeks ago I launched `}<a parentName="p" {...{
        "href": "http://postme.me"
      }}>{`Postme.me`}</a>{`, which has so far brought in infinitely more profits straight from users than all my previous projects combined. The Startup included.`}</p>
    <p>{`Actually I think I'm doing pretty great right now.`}</p>
    <p><a parentName="p" {...{
        "href": "http://postme.me"
      }}>{`Postme.me`}</a>{` is doing well and getting better, this blog is getting increasingly more traffic, I have two freelancing offers from cool startups in San Francisco on my plate (gonna have to pick), and I'm well set to graduate by next September and free myself geographically.`}</p>
    <p>{`Definitely the hardest year of my life, but I wouldn't have it any other way.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-couldnt-get-into-yc-so-i-joined-a-startup-that-did/swizec/1855"
        }}>{`I couldn't get into YC so I joined a startup that did`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://bijansabet.com/post/11734181174/there-are-so-many-options-now-for-fledgling-startups"
        }}>{`There are so many options now for fledgling startups now for seed investment and advice - YCombinators, Tech Stars, 500 Startups, etc. Should one pursue them all? Is one better than the rest? Does geography of where one is matter? Thanks in advance for`}</a>{` (bijansabet.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://davidcummings.org/2011/10/24/the-previously-strong-startup-employee-that-is-no-longer-effective/"
        }}>{`The Previously Strong Startup Employee That Is No Longer Effective`}</a>{` (davidcummings.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/doing-a-startup-taught-me-the-value-of-staying-in-school/swizec/1819"
        }}>{`Doing a startup taught me the value of staying in school`}</a>{` (swizec.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=cb3d124d-9196-4388-81ed-61579ca76ce8",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      